<template>
<div class="col-12">
    <div class="card h-100">
        <div class="card-body">
            <h4 class="card-title">
                {{ $t('news.news-analysis') }}
            </h4>
            <hr>
            <div class="row">
                <div class="col-12 mb-4">
                    <div class="clearfix">
                        <div class="card-title d-flex align-items-center justify-content-between">
                            <h5>{{ $t('news.statistics') }}</h5>
                            <div class="d-flex">
                                <div v-if="showBy == 'date'" class="d-flex">
                                    <span class="text-right mr-2 my-auto" style="width:80px">{{ $t('news.filter') }}</span>
                                    <select v-model="dateFilter" v-on:change="changeFilter" class="custom-select custom-select-sm mr-2">
                                        <option>{{ $t('news.all') }}</option>
                                        <option>{{ $t('news.last-7-day') }}</option>
                                        <option>{{ $t('news.this-month') }}</option>
                                        <option>{{ $t('news.this-year') }}</option>
                                    </select>
                                </div>
                                <div v-if="showBy == 'source'" class="d-flex">
                                    <span class="text-right mr-2 my-auto" style="width:140px">{{ $t('news.media-type') }}</span>
                                    <select v-model="sourceFilter" v-on:change="changeFilter" class="custom-select custom-select-sm mr-2">
                                        <option>{{ $t('news.all') }}</option>
                                        <option>Mainstream</option>
                                        <option>Non Mainstream</option>
                                        <option>Unknown</option>
                                    </select>
                                </div>
                                <div class="d-flex">
                                    <span class="text-right mr-2 my-auto" style="width:80px">{{ $t('news.show-by') }}</span>
                                    <b-dropdown right variant="secondary" size="sm">
                                        <template slot="button-content">
                                        {{showBy == $t('news.source') ? $t('news.source') : $t('news.publish-date') }}
                                        <i class="mdi mdi-chevron-down"></i>
                                        </template>
                                        <b-dropdown-item :class="showBy == 'source' ? 'bg-light': ''" @click="changeShow('source')">{{ $t('news.source') }}</b-dropdown-item>
                                        <b-dropdown-item :class="showBy == 'date' ? 'bg-light': ''" @click="changeShow('date')">{{ $t('news.publish-date') }}</b-dropdown-item>
                                    </b-dropdown>
                                </div>
                            </div>
                        </div>
                        <hr>
                    </div>
                    <div v-if="!nodata.statsentiment">
                        <apexchart
                        class="apex-charts"
                        height="350"
                        type="bar"
                        dir="ltr"
                        :series="seriesSentimentFilter"
                        :options="{
                            chart: {
                                toolbar: {
                                    show: false,
                                }
                            },
                            plotOptions: {
                                bar: {
                                    horizontal: false,
                                    columnWidth: '100%',
                                    endingShape: 'rounded'
                                },
                            },
                            dataLabels: {
                                enabled: false
                            },
                            stroke: {
                                show: true,
                                width: 2,
                                colors: ['transparent']
                            },
                            colors: ['#34c38f', '#38BDF8', '#f46a6a'],
                            xaxis: {
                                categories: categoriesSentimentFilter,
                            },
                            yaxis: {
                                title: {
                                    text: '% (sentiment)'
                                },
                                axisBorder: {
                                    show: true,
                                    color: '#78909C',
                                    offsetX: 0,
                                    offsetY: 0
                                },
                                max: 100,
                            },
                            grid: {
                                row: {
                                    colors: ['#f1f1f1', 'transparent'],
                                    opacity: 0.2
                                },
                                borderColor: '#f1f1f1',
                            },
                            fill: {
                                opacity: 1
                            },
                            tooltip: {
                                y: {
                                    formatter: function (val) {
                                        return val + '%'
                                    }
                                }
                            },
                            noData: {
                                text: noDataMessage.sentiment,
                                style: {
                                    fontSize: '14px',
                                }
                            }
                        }"
                        />
                    </div>
                    <div class="d-flex flex-column justify-content-center align-items-center" style="margin-top:5%;margin-bottom:5%;" v-else>
                        <i class="bx bxs-bar-chart-alt-2 bx-lg"></i>
                        <span>{{$t('all.dnf')}}</span>
                    </div>
                </div>
                <div class="col-12 mb-4">
                    <div class="clearfix">
                        <h5 class="card-title mb-4">{{$t('news.statistic-news')}}</h5>
                        <hr>
                    </div>
                    <div v-if="!nodata.statnews">
                        <apexchart
                        class="apex-charts"
                        height="380"
                        type="area"
                        dir="ltr"
                        :series="[{name: 'News', data: seriesData}]"
                        :options="{
                            chart: {
                                zoom: {
                                    enabled: false
                                },
                                toolbar: {
                                    show: false
                                }
                            },
                            colors: ['#556ee6'],
                            dataLabels: {
                                enabled: false,
                            },
                            stroke: {
                                width: 3,
                                curve: 'smooth',
                            },
                            grid: {
                                row: {
                                    colors: ['#f1f1f1', 'transparent'],
                                    opacity: 0.2
                                },
                                borderColor: '#f2f2f2'
                            },
                            markers: {
                                style: 'inverted',
                                size: 0,
                            },
                            xaxis: {
                                categories: optionCategories,
                                title: {
                                    text: $t('news.publish-date'),
                                    style: {
                                        color: theme == 'dark'? '#F8F8FB' : '#343a40',
                                        fontSize: '12px',
                                        fontFamily: 'Helvetica, Arial, sans-serif',
                                        fontWeight: 600,
                                        cssClass: 'apexcharts-xaxis-title',
                                    },
                                },
                                labels: {
                                    show: true,
                                    style: {
                                        colors: theme == 'dark'? '#F8F8FB' : '#343a40',
                                        fontSize: '10px',
                                    },
                                },
                            },
                            yaxis: {
                                title: {
                                    text: $t('news.total-news'),
                                    style: {
                                        color: theme == 'dark'? '#F8F8FB' : '#343a40',
                                        fontSize: '12px',
                                        fontFamily: 'Helvetica, Arial, sans-serif',
                                        fontWeight: 600,
                                        cssClass: 'apexcharts-xaxis-title',
                                    },
                                },
                                labels: {
                                    show: true,
                                    style: {
                                        colors: theme == 'dark'? '#F8F8FB' : '#343a40',
                                        fontSize: '10px',
                                    },
                                },
                                min: 0,
                                max: ymax
                            },
                            legend: {
                                position: 'top',
                                horizontalAlign: 'right',
                                floating: true,
                                offsetY: -25,
                                offsetX: -5
                            },
                            responsive: [{
                                breakpoint: 600,
                                options: {
                                    chart: {
                                        toolbar: {
                                            show: false
                                        }
                                    },
                                    legend: {
                                        show: false
                                    },
                                }
                            }],
                            noData: {
                                text: noDataMessage.news,
                                style: {
                                    fontSize: '14px',
                                }
                            }
                        }"
                        />
                    </div>
                    <div class="d-flex flex-column justify-content-center align-items-center" style="margin-top:5%;margin-bottom:5%;" v-else>
                        <i class="bx bxs-bar-chart-alt-2 bx-lg"></i>
                        <span> {{ $t('all.dnf') }}</span>
                    </div>
                </div>
                <div class="col-6">
                    <div class="clearfix">
                        <h5 class="card-title mb-4"> {{ $t('news.source') }}</h5>
                        <hr>
                    </div>
                    <div v-if="!loading.source">
                        <div v-if="!nodata.source">
                            <apexchart
                            class="apex-charts"
                            height="400"
                            type="donut"
                            dir="ltr"
                            :series="seriesSource"
                            :options="{
                                plotOptions: {
                                    pie: {
                                            donut: {
                                            labels: {
                                                show: true,
                                                name: {
                                                    show: true,
                                                    fontSize: '22px',
                                                    fontFamily: 'Rubik',
                                                    color: theme == 'dark'? '#F8F8FB' : '#343a40',
                                                },
                                                value: {
                                                    show: true,
                                                    fontSize: '16px',
                                                    fontFamily: 'Helvetica, Arial, sans-serif',
                                                    color: theme == 'dark'? '#F8F8FB' : '#343a40',
                                                },
                                                total: {
                                                    show: true,
                                                    label: 'Total',
                                                    color: theme == 'dark'? '#F8F8FB' : '#343a40'
                                                }
                                            }
                                        }
                                    },
                                },
                                labels: labelsSource,
                                colors: colorsSource,
                                legend: {
                                    show: true,
                                    position: 'bottom',
                                    horizontalAlign: 'center',
                                    verticalAlign: 'middle',
                                    floating: false,
                                    fontSize: '14px',
                                    offsetX: 0,
                                    offsetY: -10,
                                    labels: {
                                        colors: theme == 'dark'? '#F8F8FB' : '#343a40',
                                    }
                                },
                                responsive: [{
                                    breakpoint: 600,
                                    options: {
                                        chart: {
                                            height: 240
                                        },
                                        legend: {
                                            show: false
                                        },
                                    }
                                }]
                            }"
                            />
                        </div>
                        <div class="d-flex flex-column justify-content-center align-items-center" style="margin-top:15%;margin-bottom:15%;" v-else>
                            <i class="bx bxs-doughnut-chart bx-lg"></i>
                            <span> {{ $t('all.dnf') }}</span>
                        </div>
                    </div>
                    <div class="d-flex flex-column justify-content-center align-items-center" style="margin-top:15%;margin-bottom:15%;" v-else>
                        <i class="bx bx-loader-alt bx-lg bx-spin"></i>
                    </div>
                </div>
                <div class="col-6">
                    <div class="clearfix">
                        <h5 class="card-title mb-4"> {{ $t('news.sentiment') }}</h5>
                        <hr>
                    </div>
                    <div v-if="!loading.allsentiment">
                        <div v-if="!nodata.allsentiment">
                            <apexchart
                                class="apex-charts"
                                height="400"
                                type="pie"
                                dir="ltr"
                                :series="seriesSentiment"
                                :options="{
                                    labels: labelsSentiment,
                                    colors: colorsSentiment,
                                    legend: {
                                        show: true,
                                        position: 'bottom',
                                        horizontalAlign: 'center',
                                        verticalAlign: 'middle',
                                        floating: false,
                                        fontSize: '14px',
                                        offsetX: 0,
                                        offsetY: -10,
                                        labels: {
                                            colors: theme == 'dark'? '#F8F8FB' : '#343a40',
                                        }
                                    },
                                    responsive: [{
                                        breakpoint: 600,
                                        options: {
                                            chart: {
                                                height: 500
                                            },
                                            legend: {
                                                show: false
                                            },
                                        }
                                    }]
                                }"
                            />
                        </div>
                        <div class="d-flex flex-column justify-content-center align-items-center" style="margin-top:15%;margin-bottom:15%;" v-else>
                            <i class="bx bxs-pie-chart-alt-2 bx-lg"></i>
                            <span>{{ $t('all.dnf') }}</span>
                        </div>
                    </div>
                    <div class="d-flex flex-column justify-content-center align-items-center" style="margin-top:15%;margin-bottom:15%;" v-else>
                        <i class="bx bx-loader-alt bx-lg bx-spin"></i>
                    </div>
                </div>
            </div>
            <!-- <div class="row" v-else>
                <div class="col-12">
                    <p class="text-center">{{ $t('all.dnf') }} </p>
                </div>
            </div> -->
        </div>
    </div>
</div>
</template>

<script>
import NewsService from "@/helpers/news.service.js";
import NewscategoryService from "@/helpers/newscategory.service"
import moment from 'moment';
import simplebar from "simplebar-vue";
import { parseDomain, ParseResultType } from 'parse-domain';

export default {
    props: ['id_target'],
    
    components: { simplebar },
    data() {
        return {
            theme: localStorage.getItem('theme'),
            id: this.id_target,
            loading:{
                statsentiment: false,
                statnews: false,
                source: false,
                allsentiment: false,
            },
            nodata:{
                statsentiment: false,
                statnews: false,
                source: false,
                allsentiment: false,
            },
            noDataMessage: {
                news: 'No Data',
                sentiment: 'No Data'
            },
            loadingnew:false,
            showBy: "date",
            dateFilter: this.$t('news.all'),
            sourceFilter: this.$t('news.all'),
            title: "News",
            news: [],
            tempNews: [],
            tempSentiment: [],
            optionCategories: [],
            seriesData: [],
            ymax: 0,
            labelsSource: [],
            seriesSource: [],
            colorsSource: [],
            labelsSentiment: [],
            seriesSentiment: [],
            colorsSentiment: [],
            seriesSentimentFilter:[
                {
                    name: 'Positive',
                    data: []
                }, {
                    name: 'Nuetral',
                    data: []
                }, {
                    name: 'Negative',
                    data: []
                }
            ],
            categoriesSentimentFilter:[],
            mainstreamSource: [],
            nonmainstreamSource: []
        }
    },
    methods: {
        changeFilter(){
            this.setChartSentiment();
            this.setChartNews();
        },
        async changeShow(val){
            this.showBy = val;
            this.getSentimentFilter();
            this.getNewsAnaly();
        },
        getSentimentFilter(){
            let data = {
                "id_target" : this.id,
                "filter" : this.showBy
            }
            this.nodata.statsentiment = false;
            this.dateFilter = this.$t('news.all');
            this.noDataMessage.sentiment = 'Loading ...';
            NewsService.newsSentimentFilter(data)
            .then(response => {
                let result_array = response.data.output;
                if (this.showBy == 'date') {
                    result_array.sort(function(a,b){
                        return new Date(a.filter) - new Date(b.filter);
                    });
                }
                this.tempSentiment = result_array;
                this.setChartSentiment();
                if (response.data.output == 0) {
                    this.nodata.statsentiment = true;
                }else{
                    this.nodata.statsentiment = false;
                }
                this.noDataMessage.sentiment = 'No Data';
            })
            .catch(err => {
                this.nodata.statsentiment = true;
                this.noDataMessage.sentiment = 'No Data';
                console.log('sentiment filter -> ',err);
            })
        },
        getSentimentNews(){
            let data = {
                "id_target" : this.id
            }
            this.loading.allsentiment = true;
            this.nodata.allsentiment = false;
            NewsService.newsSentiment(data)
            .then(response => {
                if (response.data.output == 0) {
                    this.nodata.statsentiment = false;
                }
                response.data.output.forEach((el, idx) => {
                    this.labelsSentiment.push(el.sentiment);
                    this.seriesSentiment.push(el.count);
                    if (el.sentiment == 'nuetral') {
                        this.colorsSentiment.push(this.theme == 'dark' ? "#0b6d99" : "#38BDF8")
                    }else if(el.sentiment == 'positive'){
                        this.colorsSentiment.push(this.theme == 'dark' ? "#065f46" : "#34D399")
                    }else {
                        this.colorsSentiment.push(this.theme == 'dark' ? "#991b1b" : "#EF4444")
                    }
                });
                this.loading.allsentiment = false;
                if (response.data.output == 0) {
                    this.nodata.allsentiment = true;
                }else{
                    this.nodata.allsentiment = false;
                }
            })
            .catch(err => {
                this.loading.allsentiment = false;
                this.nodata.allsentiment = true;
                console.log('sentiment => ',err);
            })
        },
        getSourceNews(){
            console.log('SOURCE NEWS');
            const clr = ["#EF4444","#60A5FA","#34D399","#EAB308","#818CF8","#EC4899","#14B8A6","#F97316","#F43F5E","#38BDF8","#71717A"]
            const darkclr = ["#991b1b","#1e40af","#065f46","#a18401","#5b21b6","#9d174d","#147066","#af4b04","#c41432","#0b6d99", "#1f2937"]
            this.colorsSource = this.theme == "dark" ? darkclr : clr;
            let data = {
                "id_target" : this.id
            }
            this.loading.source = true;
            this.nodata.source = false;
            NewsService.newsSource(data)
            .then(response => {
                let otherCount = 0;
                let otherLabel = [];
                response.data.output.forEach((el, idx) => {
                    if (idx < 10) {
                        this.labelsSource.push(el.source);
                        this.seriesSource.push(el.count);
                    }
                    if (idx > 9) {
                        otherCount += el.count;
                    }
                });
                otherLabel.push('other source');
                this.labelsSource.push(otherLabel)
                this.seriesSource.push(otherCount)
                this.loading.source = false;
                if (response.data.output == 0) {
                    this.nodata.source = true;
                }else{
                    this.nodata.source = false;
                }
            })
            .catch(err => {
                this.loading.source = false;
                this.nodata.source = true;
                console.log('source => ',err);
            });
        },
        getNewsAnaly(){
            this.nodata.statnews = false;
            this.dateFilter = this.$t('news.all');
            this.noDataMessage.news = 'Loading ...';
            NewsService.newsTarget(this.id)
            .then(response => {
                this.news = response.data.data;
                this.ymax = response.data.data.length;
                // count total of date
                const counter = {};
                let news = [];
                let newsVal = [];
                if (this.showBy == 'source') {
                    response.data.data.forEach(el=> {
                        counter[el.source] = (counter[el.source] || 0) + 1;
                    });
                }else{
                    response.data.data.forEach(el=> {
                        counter[el.published_at.slice("5", "16")] = (counter[el.published_at.slice("5", "16")] || 0) + 1;
                    });
                }
                // convert to array
                Object.entries(counter).forEach(([k,v]) => {
                    news.push({"filter" : k, "count" : v});
                    newsVal.push(v);
                });
                this.ymax = Math.max(...newsVal)+5;
                // sort array by date
                const sortedArray = news.sort(function(a,b){
                    return new Date(a.filter) - new Date(b.filter);
                });
                // store data to chart
                this.tempNews = sortedArray;
                this.setChartNews();
                if (response.data.data == 0) {
                    this.nodata.statnews = true;
                }else{
                    this.nodata.statnews = false;
                }
                this.noDataMessage.news = 'No Data';
            })
            .catch(err => {
                this.nodata.statnews = true;
                console.log('news -> ',err);
                this.noDataMessage.news = 'No Data';
            });
        },
        setChartSentiment(){
            this.categoriesSentimentFilter = []
            this.seriesSentimentFilter[0].data = []
            this.seriesSentimentFilter[1].data = []
            this.seriesSentimentFilter[2].data = []
            if (this.showBy == 'date') {
                let currDate = moment();
                let last7Days = moment().subtract(7, 'days').startOf('day').format('DD MMM YYYY');
                if (this.dateFilter == 'Last 7 Day' || this.dateFilter == '7 Hari Terakhir') {
                    let daysFilter = this.tempSentiment.filter(v => moment(v.filter).isAfter(last7Days));
                    daysFilter.forEach((el, idx) => {
                        el.analysis.forEach(s => {
                            if (s.sentiment == 'positive') {
                                this.seriesSentimentFilter[0].data.push(Math.round(s.percentage))
                            }else if(s.sentiment == 'nuetral'){
                                this.seriesSentimentFilter[1].data.push(Math.round(s.percentage))
                            }else{
                                this.seriesSentimentFilter[2].data.push(Math.round(s.percentage))
                            }
                        });
                        this.categoriesSentimentFilter.push(el.filter)
                    });
                } else if(this.dateFilter == 'This Month' || this.dateFilter == 'Bulan ini'){
                    let monthFilter = this.tempSentiment.filter(v => moment(v.filter).isSame(currDate, 'month'));
                    monthFilter.forEach((el, idx) => {
                        el.analysis.forEach(s => {
                            if (s.sentiment == 'positive') {
                                this.seriesSentimentFilter[0].data.push(Math.round(s.percentage))
                            }else if(s.sentiment == 'nuetral'){
                                this.seriesSentimentFilter[1].data.push(Math.round(s.percentage))
                            }else{
                                this.seriesSentimentFilter[2].data.push(Math.round(s.percentage))
                            }
                        });
                        this.categoriesSentimentFilter.push(el.filter)
                    });
                } else if(this.dateFilter == 'This Year' || this.dateFilter == 'Tahun ini'){
                    let yearFilter = this.tempSentiment.filter(v => moment(v.filter).isSame(currDate, 'year'));
                    yearFilter.forEach((el, idx) => {
                        el.analysis.forEach(s => {
                            if (s.sentiment == 'positive') {
                                this.seriesSentimentFilter[0].data.push(Math.round(s.percentage))
                            }else if(s.sentiment == 'nuetral'){
                                this.seriesSentimentFilter[1].data.push(Math.round(s.percentage))
                            }else{
                                this.seriesSentimentFilter[2].data.push(Math.round(s.percentage))
                            }
                        });
                        this.categoriesSentimentFilter.push(el.filter)
                    });
                } else {
                    this.tempSentiment.forEach((el, idx) => {
                        el.analysis.forEach(s => {
                            if (s.sentiment == 'positive') {
                                this.seriesSentimentFilter[0].data.push(Math.round(s.percentage))
                            }else if(s.sentiment == 'nuetral'){
                                this.seriesSentimentFilter[1].data.push(Math.round(s.percentage))
                            }else{
                                this.seriesSentimentFilter[2].data.push(Math.round(s.percentage))
                            }
                        });
                        this.categoriesSentimentFilter.push(el.filter)
                    });
                }
            } else{
                if (this.sourceFilter == 'Mainstream') {
                    this.tempSentiment.forEach((el, idx) => {
                        if (this.mainstreamSource.includes(this.getDomain(el.filter))) {
                            el.analysis.forEach(s => {
                                if (s.sentiment == 'positive') {
                                    this.seriesSentimentFilter[0].data.push(Math.round(s.percentage))
                                }else if(s.sentiment == 'nuetral'){
                                    this.seriesSentimentFilter[1].data.push(Math.round(s.percentage))
                                }else{
                                    this.seriesSentimentFilter[2].data.push(Math.round(s.percentage))
                                }
                            });
                            this.categoriesSentimentFilter.push(el.filter)
                        }
                    });
                }else if(this.sourceFilter == 'Non Mainstream'){
                    this.tempSentiment.forEach((el, idx) => {
                        if (this.nonmainstreamSource.includes(this.getDomain(el.filter))) {
                            el.analysis.forEach(s => {
                                if (s.sentiment == 'positive') {
                                    this.seriesSentimentFilter[0].data.push(Math.round(s.percentage))
                                }else if(s.sentiment == 'nuetral'){
                                    this.seriesSentimentFilter[1].data.push(Math.round(s.percentage))
                                }else{
                                    this.seriesSentimentFilter[2].data.push(Math.round(s.percentage))
                                }
                            });
                            this.categoriesSentimentFilter.push(el.filter)
                        }
                    });
                }else if(this.sourceFilter == 'Unknown'){
                    let allSource = this.mainstreamSource.concat(this.nonmainstreamSource);
                    console.log('all source =>> ',allSource);
                    this.tempSentiment.forEach((el, idx) => {
                        if (!allSource.includes(this.getDomain(el.filter))) {
                            el.analysis.forEach(s => {
                                if (s.sentiment == 'positive') {
                                    this.seriesSentimentFilter[0].data.push(Math.round(s.percentage))
                                }else if(s.sentiment == 'nuetral'){
                                    this.seriesSentimentFilter[1].data.push(Math.round(s.percentage))
                                }else{
                                    this.seriesSentimentFilter[2].data.push(Math.round(s.percentage))
                                }
                            });
                            this.categoriesSentimentFilter.push(el.filter);
                        }
                    });
                }else{
                    this.tempSentiment.forEach((el, idx) => {
                        el.analysis.forEach(s => {
                            if (s.sentiment == 'positive') {
                                this.seriesSentimentFilter[0].data.push(Math.round(s.percentage))
                            }else if(s.sentiment == 'nuetral'){
                                this.seriesSentimentFilter[1].data.push(Math.round(s.percentage))
                            }else{
                                this.seriesSentimentFilter[2].data.push(Math.round(s.percentage))
                            }
                        });
                        this.categoriesSentimentFilter.push(el.filter)
                    });
                }
            }
        },
        setChartNews(){
            this.optionCategories = [];
            this.seriesData = [];
            if (this.showBy == 'date') {
                let currDate = moment();
                let last7Days = moment().subtract(7, 'days').startOf('day').format('DD MMM YYYY');
                if (this.dateFilter == 'Last 7 Day' || this.dateFilter == '7 Hari Terakhir') {
                    let daysFilter = this.tempNews.filter(v => moment(v.filter).isAfter(last7Days));
                    daysFilter.forEach(el => {
                        this.optionCategories.push(el.filter)
                        this.seriesData.push(el.count)
                    });
                } else if(this.dateFilter == 'This Month' || this.dateFilter == 'Bulan ini'){
                    let monthFilter = this.tempNews.filter(v => moment(v.filter).isSame(currDate, 'month'));
                    monthFilter.forEach(el => {
                        this.optionCategories.push(el.filter)
                        this.seriesData.push(el.count)
                    });
                } else if(this.dateFilter == 'This Year' || this.dateFilter == 'Tahun ini'){
                    let yearFilter = this.tempNews.filter(v => moment(v.filter).isSame(currDate, 'year'));
                    yearFilter.forEach(el => {
                        this.optionCategories.push(el.filter)
                        this.seriesData.push(el.count)
                    });
                } else {
                    this.tempNews.forEach(el => {
                        this.optionCategories.push(el.filter)
                        this.seriesData.push(el.count)
                    });
                }
            } else{
                if (this.sourceFilter == 'Mainstream') {
                    this.tempNews.forEach(el => {
                        if (this.mainstreamSource.includes(this.getDomain(el.filter))) {
                            this.optionCategories.push(el.filter)
                            this.seriesData.push(el.count)
                        }
                    });
                }else if(this.sourceFilter == 'Non Mainstream'){
                    this.tempNews.forEach(el => {
                        if (this.nonmainstreamSource.includes(this.getDomain(el.filter))) {
                            this.optionCategories.push(el.filter)
                            this.seriesData.push(el.count)
                        }
                    });
                }else if(this.sourceFilter == 'Unknown'){
                    let allSource = this.mainstreamSource.concat(this.nonmainstreamSource);
                    this.tempNews.forEach(el => {
                        if (!allSource.includes(this.getDomain(el.filter))) {
                            this.optionCategories.push(el.filter)
                            this.seriesData.push(el.count)
                        }
                    });
                }else{
                    this.tempNews.forEach(el => {
                        this.optionCategories.push(el.filter)
                        this.seriesData.push(el.count)
                    });
                }
            }
        },
        getNewsCategory(){
            NewscategoryService.list()
            .then(response => {
                this.mainstreamSource = [];
                this.nonmainstreamSource = [];
                response.data.data.forEach(val => {
                    if (val.source_category == 'Mainstream') {
                        this.mainstreamSource.push(this.getDomain(val.source_domain))
                    }
                    if (val.source_category == 'Non Mainstream') {
                        this.nonmainstreamSource.push(this.getDomain(val.source_domain))
                    }
                });
            })
            .catch(err => {
                console.log(err);
            });
        },
        getDomain(url){
            const parseResult = parseDomain(url);
            if (parseResult.type === ParseResultType.Listed) {
                const {domain} = parseResult;
                return domain;
            }else{
                return url;
            }
        }
    },
    beforeMount(){
        this.getNewsCategory();
        this.getNewsAnaly();
    },
    mounted(){
        this.getSourceNews();
        this.getSentimentNews();
        this.getSentimentFilter();
    },
};
</script>